import { Grid2 as Grid } from "@mui/material"
import Button from "@mui/material/Button"
import { Field, Formik } from "formik"
import { useMemo } from "react"
import * as yup from "yup"
import { Vocabolario } from "../../types"
import { transformErrorForForm } from "../../utils/utils"
import { FormInDialogProps } from "../DialogForm"
import { FormikTextField, SelectTipologiaVocabolario } from "./formsHelpers"
import { useTranslation } from "react-i18next"

export default function VocaboloForm({ item, save, ref, vocabolario }: FormInDialogProps<Vocabolario> & { vocabolario?: string }) {
  const { t } = useTranslation()
  const initialValues = useMemo(() => {
    return (
      item ?? {
        termine_en: "",
        termine_it: "",
        vocabolario: vocabolario ?? "",
      }
    )
  }, [item, vocabolario])

  const schema = useMemo(
    () =>
      yup.object().shape({
        termine_it: yup.string().required().label(t("vocabolario.termine_it")),
        vocabolario: yup.string().required().label(t("vocabolario.vocabolario")),
      }),
    [t]
  )

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as Vocabolario).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit, values, setFieldValue, errors, touched, submitCount, setFieldTouched }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={12}>
                <SelectTipologiaVocabolario
                  disabled={!!vocabolario}
                  label={t("vocabolario.vocabolario")}
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  error={
                    errors.vocabolario && (touched.vocabolario || submitCount > 0) ? errors.vocabolario : undefined
                  }
                  submitCount={submitCount}
                  value={values.vocabolario}
                  onChange={(e) => {
                    setFieldValue("vocabolario", e.target.value)
                  }}
                  onBlur={() => {
                    setFieldTouched("vocabolario", true)
                  }}
                  readOnly={!!vocabolario}
                ></SelectTipologiaVocabolario>
              </Grid>
              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  name="termine_it"
                  label={t("vocabolario.termine_it")}
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  name="termine_en"
                  label={t("vocabolario.termine_en")}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
